export { default } from './QrCodeModalCrypto';
